import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, AlertTriangle } from 'lucide-react';

export default function GoogleCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const isSuccess = params.get('calendar') === 'connected';

  useEffect(() => {
    const timer = setTimeout(() => navigate('/partner/settings'), 2000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--bg-base)' }}>
      <div className="text-center space-y-3 p-8 rounded-2xl" style={{ background: 'var(--bg-surface-raised)', border: '1px solid var(--border-primary)' }}>
        {isSuccess ? (
          <>
            <CheckCircle size={40} className="mx-auto" style={{ color: 'var(--success-dot)' }} />
            <p className="text-base font-semibold" style={{ color: 'var(--text-primary)' }}>Google Agenda gekoppeld!</p>
            <p className="text-sm" style={{ color: 'var(--text-muted)' }}>Je wordt doorgestuurd naar de instellingen...</p>
          </>
        ) : (
          <>
            <AlertTriangle size={40} className="mx-auto" style={{ color: 'var(--danger-text)' }} />
            <p className="text-base font-semibold" style={{ color: 'var(--text-primary)' }}>Koppeling niet gelukt</p>
            <p className="text-sm" style={{ color: 'var(--text-muted)' }}>Je wordt doorgestuurd naar de instellingen...</p>
          </>
        )}
      </div>
    </div>
  );
}
